function initiShippingInsuranceToggle() {
  const toggle = document.getElementById("shipping-insurance-toggle");
  if (!toggle || toggle.dataset.listenerAttached === "true") return;

  toggle.dataset.listenerAttached = "true";

  function formatMoney(cents, currency = '€') {
    let euros = cents / 100;
    return `${euros.toFixed(2).replace('.', ',')} €`;
  }

  const updateCartUI = () => {
    const subtotalElement = document.querySelector('.wt-cart__subtotal__value');
    const cartCountElement = document.querySelector('.wt-header__panel__counter');

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (subtotalElement) {
          subtotalElement.classList.add('updating');
          subtotalElement.textContent = formatMoney(cart.total_price);
          setTimeout(() => {
            subtotalElement.classList.remove('updating');
          }, 400);
        }

        // 🛒 Update cart count
        if (cartCountElement) {
          const count = cart.items.reduce((acc, item) => {
            return item.handle === "zavarovanje-paketa" ? 0 : acc + item.quantity;
          }, 0);

          // Show or hide the badge depending on count
          if (count > 0) {
            cartCountElement.textContent = count;
            cartCountElement.style.color = "white !important";
          } else {
            cartCountElement.style.display = 'none';
          }
        }
      });
  };

  toggle.addEventListener("change", function () {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const insuranceItem = cart.items.find(
          (i) => i.handle === window.INSURANCE_PRODUCT_HANDLE
        );
        if (this.checked && !insuranceItem) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  quantity: 1,
                  id: window.INSURANCE_PRODUCT_ID,
                },
              ],
            }),
          }).then(updateCartUI);
        } else if (!this.checked && insuranceItem) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: insuranceItem.key,
              quantity: 0,
            }),
          }).then(updateCartUI);
        }
      });
  });
}

function setupObserverForDrawer() {
  const targetDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
  initiShippingInsuranceToggle();
  if (!targetDrawer) return;
  const observer = new MutationObserver(() => {
    initiShippingInsuranceToggle();
  });

  observer.observe(targetDrawer, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", setupObserverForDrawer);
document.addEventListener("shopify:section:load", setupObserverForDrawer);